import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { SocialButton } from '@change-corgi/design-system-legacy/components/social';
import { iconCheck } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { useCopyLinkButton } from 'src/app/pages/starterDashboardV2/shared/hooks';

type CopyLinkButtonProps = { shareUrl: string };
export function CopyLinkButton({ shareUrl }: CopyLinkButtonProps): JSX.Element {
	const { data, actions } = useCopyLinkButton({ shareUrl });

	return (
		<SocialButton
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			channel="copy"
			onClick={actions.handleShare}
			size="medium"
			sx={{ width: ['100%', '100%', 'auto'], flexShrink: 1, maxHeight: 44 }}
		>
			<Flex sx={{ alignItems: 'center' }}>
				{data.copied ? (
					<>
						<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.copy_success" />
						<Icon icon={iconCheck} size={20} ml={4} color="typography-positive" />
					</>
				) : (
					<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.copy_button" />
				)}
			</Flex>
		</SocialButton>
	);
}
